export const AUDIT_TYPE_OPTIONS = [
  'Create',
  'Update',
  'Delete',
  'Access',
  'Failed',
] as const;

export type AuditTypeOption = typeof AUDIT_TYPE_OPTIONS[number];
